const indexItems = [
  { title: '娱乐圈塌房实录', desc: '收录近年明星塌房全记录', icon: 'ri-building-4-line', count: '128篇' },
  { title: '网红翻车合集', desc: '盘点网红圈翻车名场面', icon: 'ri-car-line', count: '96篇' },
  { title: '综艺内幕深扒', desc: '揭秘综艺节目制作内幕', icon: 'ri-tv-2-line', count: '73篇' },
  { title: '品牌代言风波', desc: '追踪品牌代言人风波事件', icon: 'ri-store-3-line', count: '61篇' },
  { title: '恋情实锤档案', desc: '明星恋情爆料时间线整理', icon: 'ri-heart-line', count: '89篇' },
  { title: '饭圈动态追踪', desc: '饭圈撕逼与数据打假记录', icon: 'ri-fire-line', count: '115篇' },
  { title: '法律纠纷档案', desc: '明星涉及法律纠纷全记录', icon: 'ri-scales-3-line', count: '42篇' },
  { title: '时尚圈黑幕', desc: '时尚圈利益链与潜规则曝光', icon: 'ri-shirt-line', count: '37篇' },
  { title: '直播带货打假', desc: '头部主播带货翻车事件汇总', icon: 'ri-live-line', count: '55篇' },
];

export function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">专题索引</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">按专题分类浏览，快速找到你感兴趣的吃瓜内容</p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-4 p-4 rounded-lg border border-background-200/50 bg-background-100 hover:border-primary-500/30 hover:bg-background-100/80 transition-all"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl text-primary-400`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-700 group-hover:text-primary-400 transition-colors">{item.title}</p>
                <p className="text-xs text-foreground-400 mt-0.5 truncate">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

const carouselItems = [
  {
    title: '某顶流男星背后的资本博弈',
    desc: '从综艺翻车到品牌解约，深挖某顶流男星背后的资本局中局，涉及多家上市公司和品牌方利益链。',
    tag: '深扒专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20red%20curtain%20and%20spotlight%2C%20mysterious%20silhouette%20on%20stage%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20theatrical%20atmosphere%2C%20dark%20background%20with%20warm%20accent%20light%2C%20film%20noir%20style%2C%20editorial%20photography&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '综艺剧本流出：真人秀到底有多假',
    desc: '独家整理近期多档热门综艺剧本细节，揭秘真人秀的"真"与"假"，导演组操控现场的手段全曝光。',
    tag: '独家揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20backstage%20area%20with%20scripts%20scattered%20on%20table%2C%20dim%20red%20lighting%2C%20shadowy%20figures%20behind%20scenes%2C%20theatrical%20behind%20the%20curtain%20vibe%2C%20dark%20atmosphere%20with%20subtle%20warm%20glow%2C%20cinematic%20documentary%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '网红圈年度大瓜时间线全梳理',
    desc: '从年初到年末，网红圈最劲爆的十大翻车事件全记录，涉事主播、品牌方、MCN机构的完整关系网。',
    tag: '年度盘点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20detective%20investigation%20board%20with%20red%20strings%20connecting%20photos%20and%20notes%2C%20mysterious%20evidence%20wall%2C%20dramatic%20lighting%20with%20shadows%2C%20investigative%20journalism%20aesthetic%2C%20dark%20background%20with%20spotlight%20effects&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '品牌代言人风波：谁在操纵舆论',
    desc: '近期多个品牌紧急更换代言人背后，社交媒体舆论操纵和水军操作的手法全揭秘，吃瓜群众如何辨别真假。',
    tag: '舆论分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20control%20room%20with%20multiple%20screens%20displaying%20social%20media%20feeds%2C%20dark%20atmosphere%20with%20red%20accent%20lights%2C%20shadowy%20figure%20at%20console%2C%20cyber%20operations%20vibe%2C%20dramatic%20cinematic%20lighting&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">焦点深扒</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">深度调查专题报道，揭开事件背后的真相</p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <div key={i} className="group rounded-lg overflow-hidden border border-background-200/50 bg-background-50 hover:border-primary-500/20 transition-all">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-medium rounded bg-primary-500/90 text-background-50">{item.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-800 group-hover:text-primary-400 transition-colors">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const cardItems = [
  {
    title: '某女星离婚内幕曝光，财产分割细节惊人',
    desc: '独家获取相关法律文件，揭秘某知名女星离婚案背后的惊人财产分割细节和抚养权争夺内幕。',
    tag: '独家爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20interior%20with%20legal%20documents%20on%20table%2C%20mysterious%20atmosphere%2C%20soft%20red%20accent%20lighting%2C%20dramatic%20shadows%2C%20confidential%20vibe%2C%20editorial%20style%20photography&width=600&height=380&seq=card-01&orientation=landscape',
  },
  {
    title: '饭圈大粉卷款跑路，涉案金额超千万',
    desc: '某顶流粉丝后援会大粉被曝卷走应援集资款，受害粉丝遍布全国，事件正在持续发酵中。',
    tag: '社会热点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20scattered%20money%20and%20fan%20merchandise%2C%20mysterious%20shadows%2C%20red%20accent%20lighting%2C%20crime%20investigation%20vibe%2C%20dark%20atmosphere%20with%20spotlight%20on%20evidence&width=600&height=380&seq=card-02&orientation=landscape',
  },
  {
    title: '综艺导师被曝收取选手好处费',
    desc: '知情人爆料某选秀综艺导师涉嫌私下收取选手好处费影响比赛结果，节目组已启动内部调查。',
    tag: '内幕消息',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20corridor%20with%20envelope%20exchange%20silhouette%2C%20mysterious%20meeting%2C%20dramatic%20noir%20lighting%2C%20secret%20transaction%20vibe%2C%20dark%20atmosphere%20with%20red%20highlights&width=600&height=380&seq=card-03&orientation=landscape',
  },
  {
    title: '品牌方内部邮件泄露，代言人选择标准曝光',
    desc: '某国际品牌内部邮件意外流出，透露品牌选择代言人的详细标准和评估流程，引发业内震动。',
    tag: '数据泄露',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20office%20scene%20with%20computer%20screen%20glowing%2C%20confidential%20documents%2C%20mysterious%20atmosphere%2C%20red%20accent%20lighting%2C%20data%20breach%20vibe%2C%20cinematic%20thriller%20style&width=600&height=380&seq=card-04&orientation=landscape',
  },
  {
    title: '圈内大佬聚会录音曝光，内容劲爆',
    desc: '一段圈内大佬私人聚会录音被匿名投稿至暗网吃瓜，内容涉及多位知名艺人，真实性有待核实。',
    tag: '重磅炸弹',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20private%20dining%20room%20with%20recording%20device%20on%20table%2C%20mysterious%20gathering%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20secret%20meeting%20vibe%2C%20noir%20cinematography%20style&width=600&height=380&seq=card-05&orientation=landscape',
  },
];

export function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">热门爆料</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">全网最火的黑料爆料，每一条都让你大呼过瘾</p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className="group rounded-lg overflow-hidden border border-background-200/50 bg-background-100 hover:border-primary-500/20 transition-all">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded bg-accent-500/90 text-background-50">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {['8.3','6.7','5.2','4.1','9.5'][i]}万</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> {[856,623,487,312,1024][i]}</span>
                  <span className="flex items-center gap-1 ml-auto"><i className="ri-time-line"></i> {[2,5,8,13,1][i]}小时前</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const topicItems = [
  { name: '明星塌房', heat: '9.8万', trend: 'up', color: 'primary' },
  { name: '综艺剧本', heat: '8.5万', trend: 'up', color: 'accent' },
  { name: '网红翻车', heat: '7.2万', trend: 'up', color: 'primary' },
  { name: '代言风波', heat: '6.8万', trend: 'down', color: 'secondary' },
  { name: '恋情曝光', heat: '6.1万', trend: 'up', color: 'accent' },
  { name: '饭圈撕逼', heat: '5.4万', trend: 'up', color: 'primary' },
  { name: '剧组内幕', heat: '4.9万', trend: 'down', color: 'secondary' },
  { name: '数据造假', heat: '4.3万', trend: 'up', color: 'primary' },
  { name: '合同纠纷', heat: '3.7万', trend: 'up', color: 'accent' },
  { name: '直播翻车', heat: '3.2万', trend: 'down', color: 'secondary' },
  { name: '隐婚生子', heat: '2.8万', trend: 'up', color: 'primary' },
];

export function TopicsSection() {
  const colorStyles: Record<string, string> = {
    primary: 'bg-primary-500/10 text-primary-400 border-primary-500/20 hover:bg-primary-500/20',
    accent: 'bg-accent-500/10 text-accent-400 border-accent-500/20 hover:bg-accent-500/20',
    secondary: 'bg-secondary-500/10 text-secondary-400 border-secondary-500/20 hover:bg-secondary-500/20',
  };

  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">话题广场</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">大家都在热议的话题，点击加入讨论</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {topicItems.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition-all ${colorStyles[topic.color]}`}
            >
              <span>{topic.name}</span>
              <span className="text-xs opacity-70">{topic.heat}</span>
              {topic.trend === 'up' ? (
                <i className="ri-arrow-up-line text-xs"></i>
              ) : (
                <i className="ri-arrow-down-line text-xs"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}